/* eslint-disable @typescript-eslint/camelcase */
import L from 'leaflet'

import { css } from 'styled-components'

import { lighten, readableColor } from 'polished'

const selected = { inner1: '#e32636', inner2: '#CF352E', outer1: '#7f1734', outer2: '#9b111e' }

const notSelected = { inner1: '#126fc6', inner2: '#4c9cd1', outer1: '#2e6c97', outer2: '#3883b7' }
const asset_types = {
    crew: 'crew',
    airplane: 'airplane',
    well: 'well',
    ship: 'ship',
    windmill: 'windmill',
    factory: 'factory',
    car: 'car',
    worker: 'worker'
}

export function getMarkerIcon(asset_type, selectedStatus, assetEvent) {
    function getDivClass() {
        const select = selectedStatus ? 'selectedAssetMarkerIcon' : 'assetMarkerIcon'

        return `${select} withAssetIcon`
    }
    const color1 = assetEvent.color ?? '#126fc6'
    const strokeColor = lighten(0.2, color1)
    const color2 = lighten(0.3, color1)
    const textColor = readableColor(strokeColor)

    let assetIcon = assetEvent.icon

    if (!assetIcon) {
        switch (asset_type) {
            case asset_types.crew:
                assetIcon = 'fas fa-truck'
                break
            case asset_types.airplane:
                assetIcon = 'fas fa-plane'
                break
            case asset_types.well:
                assetIcon = 'fas fa-tint'
                break
            case asset_types.ship:
                assetIcon = 'fas fa-ship'
                break
            case asset_types.windmill:
                assetIcon = 'fas fa-wind-turbine'
                break
            case asset_types.factory:
                assetIcon = 'fas fa-industry-alt'
                break
            case asset_types.car:
                assetIcon = 'fas fa-car'
                break
            case asset_types.worker:
                assetIcon = 'fas fa-user-hard-hat'
                break

            default:
                assetIcon = assetEvent.icon ?? 'fas fa-circle'
                break
        }
    }

    return L.divIcon({
        className: getDivClass(),
        html: `<span style="--color-1:${color1}; --color-2:${color2}; --strokeColor:${strokeColor}; --textColor:${textColor}">
            <i class="fas fa-map-marker bg"></i> <i class="${assetIcon} assetIcon"></i>
        </span>`,
        iconAnchor: [0, 0],
        popupAnchor: [0, -55]
    })
}
export const markerStyles = theme => css`
    .assetMarkerIcon,
    .selectedAssetMarkerIcon {
        transition: font-size 0.3s;

        .bg {
            -webkit-text-stroke: 2px var(--strokeColor);

            &:before {
                background-clip: text;
                -webkit-text-fill-color: var(--color-2);
            }
        }

        .assetIcon {
            color: var(--textColor);
        }

        i {
            position: absolute;
            transform: translate(-50%, -100%);
        }
    }
    .assetMarkerIcon {
        font-size: 30px;
    }
    .selectedAssetMarkerIcon {
        font-size: 40px;

        i {
            &.bg {
                -webkit-text-stroke: 2px #ff706b;

                &:before {
                    background: ${theme == 'light'
                        ? 'linear-gradient(to top, #fff 0%, #fff 100%)'
                        : 'linear-gradient(to top, #000 0%, #000 100%)'};
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
            &.ft {
                &:before {
                    background: linear-gradient(to top, #e32636 0%, #cf352e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
        }
    }
    .withAssetIcon {
        &.assetMarkerIcon {
            font-size: 45px;

            .assetIcon {
                transform: translate(-50%, -35px);
                font-size: 13px;
            }
        }
        &.selectedAssetMarkerIcon {
            font-size: 55px;
            .bg {
                &:before {
                    background: linear-gradient(to top, #e32636 0%, #cf352e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
            .assetIcon {
                transform: translate(-50%, -45px);
                font-size: 18px;
            }
        }
    }
`
